const games = [
  {
    id: "reh-dogg-arcade-mayhem",
    title: "Reh Dogg Arcade: Mayhem",
    description: "Survive enemy waves, evolve your weapons, and conquer a five-stage 3D journey.",
    genre: "Survival",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/reh-dogg-arcade-mayhem",
    thumbnail: "https://img.itch.zone/aW1nLzI5OTQ1MTMzLnBuZw==/original/e4Ag34.png",
  },
  {
    id: "reh-dogg-arcade-agent-8-ball",
    title: "Reh Dogg Arcade: Agent 8-Ball",
    description: "Sink shots, beat the clock, and defuse the danger in an arcade pool challenge.",
    genre: "Sports",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/reh-dogg-arcade-agent-8-ball",
    thumbnail: "https://img.itch.zone/aW1nLzI5NDU5NTMyLnBuZw==/original/RTrgE7.png",
  },
  {
    id: "reh-dogg-arcade-hyperdrive",
    title: "Reh Dogg Arcade: Hyperdrive",
    description: "Boost through neon city tracks and dodge barriers in a futuristic hovercraft racer.",
    genre: "Racing",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/reh-dogg-arcade-hyperdrive",
    thumbnail: "https://img.itch.zone/aW1nLzI5NDUwOTk4LnBuZw==/original/5ag74l.png",
  },
  {
    id: "reh-dogg-forest-of-the-forgotten",
    title: "Reh Dogg: Forest of the Forgotten",
    description: "A first-person psychological horror adventure where you uncover the truth.",
    genre: "Horror",
    price: "Premium",
    url: "https://rehdogggamesplus.itch.io/reh-dogg-forest-of-the-forgotten",
    thumbnail: "https://img.itch.zone/aW1nLzI4MDEzMDk5LmpwZw==/315x250%23c/6LfENA.jpg",
  },
  {
    id: "chip-cha-iro-forest-treat-adventure-demo",
    title: "Chip Cha Iro: Forest Treat Adventure DEMO",
    description: "A playable Windows demo featuring the first 3 stages of the game.",
    genre: "Platformer",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/chip-cha-iro-forest-treat-adventure-demo",
    thumbnail: "https://img.itch.zone/aW1nLzI3ODczMzMxLnBuZw==/315x250%23c/T%2BT08%2F.png",
  },
  {
    id: "chip-cha-iro",
    title: "Chip Cha Iro: Forest Treat Adventure",
    description: "Experience the complete adventure with all stages, challenges, and the full ending.",
    genre: "Platformer",
    price: "Premium",
    url: "https://rehdogggamesplus.itch.io/chip-cha-iro-forest-treat-adventure",
    thumbnail: "https://img.itch.zone/aW1nLzI3ODcyOTY0LmpwZw==/315x250%23c/fFDkvU.jpg",
  },
  {
    id: "terra-snout-deep-dig-demo",
    title: "Terra Snout: Deep Dig DEMO",
    description: "Deep Dig and survive an underground arcade adventure filled with fire ants, golden ants, and falling boulders.",
    genre: "Platformer",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/terra-snout-deep-dig-demo",
    thumbnail: "https://img.itch.zone/aW1nLzI3ODM3OTY2LmpwZw==/315x250%23c/ivNYSm.jpg",
  },
  {
    id: "terra-snout-deep-dig",
    title: "Terra Snout: Deep Dig",
    description: "Dig deep. Collect golden ants. Crush enemies with falling boulders.",
    genre: "Platformer",
    price: "Premium",
    url: "https://rehdogggamesplus.itch.io/terra-snout-deep-dig",
    thumbnail: "https://img.itch.zone/aW1nLzI3ODM3NTcyLmpwZw==/315x250%23c/FLmY8y.jpg",
  },
  {
    id: "where-he-at",
    title: "WHERE HE AT? Find Reh Dogg Before Time Runs Out!",
    description: "Search-and-find gameplay with an urban arcade twist.",
    genre: "Puzzle",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/where-he-at-find-reh-dogg-before-time-runs-out",
    thumbnail: "https://img.itch.zone/aW1nLzI3NjAzNTA0LnBuZw==/315x250%23c/PVERiy.png",
  },
  {
    id: "booking-empire-wrestling-demo",
    title: "Booking Empire: Wrestling Management Strategy Game Demo",
    description: "Try the wrestling management strategy game demo.",
    genre: "Strategy",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/booking-empire-wrestling-management-strategy-game-demo",
    thumbnail: "https://img.itch.zone/aW1nLzI3NTY0NTU0LmpwZw==/315x250%23c/nElN3c.jpg",
  },
  {
    id: "booking-empire-wrestling",
    title: "Booking Empire: Wrestling Management Strategy Game",
    description: "Manage your wrestling promotion and book epic shows.",
    genre: "Strategy",
    price: "Premium",
    url: "https://rehdogggamesplus.itch.io/booking-empire-wrestling-management-strategy-game",
    thumbnail: "https://img.itch.zone/aW1nLzI3NTY0MTQ3LmpwZw==/315x250%23c/a4WkPq.jpg",
  },
  {
    id: "the-blacken-chinese-man-demo",
    title: "The Blacken Chinese Man: The Hong Kong Curse Demo",
    description: "Play Stage 1 of the cinematic FMV action thriller before buying the full game.",
    genre: "Action",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/the-blacken-chinese-man-the-hong-kong-curse-demo",
    thumbnail: "https://img.itch.zone/aW1nLzI3NDM0OTcyLnBuZw==/315x250%23c/j3oMN1.png",
  },
  {
    id: "the-blacken-chinese-man",
    title: "The Blacken Chinese Man: The Hong Kong Curse",
    description: "A dark cinematic FMV action thriller where quick decisions determine survival against an ancient curse in Hong Kong.",
    genre: "Action",
    price: "Premium",
    url: "https://rehdogggamesplus.itch.io/the-blacken-chinese-man-the-hong-kong-curse",
    thumbnail: "https://img.itch.zone/aW1nLzI3NDM0MzU3LmpwZw==/315x250%23c/SjcqQh.jpg",
  },
  {
    id: "suds-of-fury",
    title: "REH DOGG: SUDS OF FURY - Interactive Arcade Movie",
    description: "A fast-paced neon FMV arcade experience where Sudsy battles mutant sewer monsters.",
    genre: "Interactive Fiction",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/reh-dogg-suds-of-fury-interactive-arcade-movie",
    thumbnail: "https://img.itch.zone/aW1nLzI3MTc3NTY1LnBuZw==/315x250%23c/pBSjA2.png",
  },
  {
    id: "fire-speed-boat-rush",
    title: "Fire Speed Boat Rush",
    description: "Race across the water in a fast arcade boat challenge.",
    genre: "Racing",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/fire-speed-boat-rush",
    thumbnail: "https://img.itch.zone/aW1nLzI3MTIxMDI4LmpwZw==/315x250%23c/J0cND8.jpg",
  },
  {
    id: "arcade-word-search",
    title: "Arcade Word Search",
    description: "Find hidden words in a quick arcade puzzle game.",
    genre: "Puzzle",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/arcade-word-search",
    thumbnail: "https://img.itch.zone/aW1nLzI3MTIwOTg4LmpwZw==/315x250%23c/TnaypU.jpg",
  },
  {
    id: "reh-dogg-clean-the-city",
    title: "Reh Dogg: Clean the City",
    description: "Clean up the city in an action arcade challenge.",
    genre: "Action",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/reh-dogg-clean-the-city",
    thumbnail: "https://img.itch.zone/aW1nLzI3MTIwNDg3LmpwZw==/315x250%23c/8cmw4l.jpg",
  },
  {
    id: "neon-run",
    title: "Reh Dogg GP: Neon Run",
    description: "Endless neon runner.",
    genre: "Racing",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/reh-dogg-gp-neon-run",
    thumbnail: "https://img.itch.zone/aW1nLzI3MTIwMDkxLmpwZw==/315x250%23c/GcSfqu.jpg",
  },
  {
    id: "block-wars-break-out-arena",
    title: "Block Wars: Break Out Arena",
    description: "Break blocks and survive the arena in a browser arcade game.",
    genre: "Action",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/block-wars-break-out-arena",
    thumbnail: "https://img.itch.zone/aW1nLzI3MTE5OTQ3LmpwZw==/315x250%23c/m05gZQ.jpg",
  },
  {
    id: "star-duel-3d",
    title: "Reh Dogg Star Duel 3D",
    description: "Dogfighting in neon space arenas.",
    genre: "Action",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/reh-dogg-star-duel-3d",
    thumbnail: "https://img.itch.zone/aW1nLzI3MTE5ODg0LmpwZw==/315x250%23c/8OTXjG.jpg",
  },
  {
    id: "bark-stars",
    title: "Bark Stars: Reh Dogg's Sudsy Squad",
    description: "Survive waves with the Sudsy Squad.",
    genre: "Survival",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/bark-stars-reh-doggs-sudsy-squad",
    thumbnail: "https://img.itch.zone/aW1nLzI3MTE5ODE1LmpwZw==/315x250%23c/SyqFGZ.jpg",
  },
  {
    id: "chip-maggie-kibble-quest",
    title: "Chip & Maggie: Kibble Quest",
    description: "Collect kibble and take on a playful arcade quest.",
    genre: "Action",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/chip-maggie-kibble-quest",
    thumbnail: "https://img.itch.zone/aW1nLzI3MTE5NTk3LmpwZw==/315x250%23c/eHSMGD.jpg",
  },
  {
    id: "marcus",
    title: "Marcus: Santo Domingo Street Justice",
    description: "Street-level survival and justice.",
    genre: "Survival",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/marcus-santo-domingo-street-justice",
    thumbnail: "https://img.itch.zone/aW1nLzI3MTE5NDc3LmpwZw==/315x250%23c/i3tZk0.jpg",
  },
  {
    id: "hoop-pin-strike",
    title: "Hoop & Pin Strike: Arcade Sports Training Game",
    description: "Train your aim. Beat the clock. Master the strike.",
    genre: "Simulation",
    price: "Free",
    url: "https://rehdogggamesplus.itch.io/hoop-pin-strike-arcade-sports-training-game",
    thumbnail: "https://img.itch.zone/aW1nLzI3MTE4ODAyLnBuZw==/315x250%23c/fzHPMH.png",
  },
];

export default games;
